var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAavaxb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(0 0.5)",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83126 0.81357C8.55472 0.395477 9.44606 0.395477 10.1695 0.81357L15.9313 4.14331C16.6547 4.5614 17.1004 5.33407 17.1004 6.17026V12.8297C17.1004 13.6659 16.6547 14.4386 15.9313 14.8567L10.1695 18.1864C9.44606 18.6045 8.55472 18.6045 7.83126 18.1864L2.06953 14.8567C1.34606 14.4386 0.900391 13.6659 0.900391 12.8297V6.17026C0.900391 5.33407 1.34606 4.5614 2.06953 4.14331L7.83126 0.81357Z",
    fill: "#006DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9142 10.1304C11.7028 9.75469 11.3646 9.75469 11.1532 10.1304L9.81844 12.4896C9.60704 12.8592 9.7822 13.1672 10.199 13.1672H12.8444C13.2671 13.1672 13.4423 12.8592 13.2309 12.4896L11.9142 10.1304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3669 7.35232L9.67233 6.10189L9.37639 5.56599C9.16502 5.19024 8.82678 5.19024 8.61538 5.56599L4.74993 12.4834C4.53854 12.8592 4.71369 13.161 5.13648 13.161H6.21156H6.94841H7.07525C7.42556 13.161 7.86041 12.9084 8.03557 12.5943L10.3669 8.47956C10.536 8.17774 10.536 7.66647 10.3669 7.35232Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAavaxb);
export default __webpack_public_path__ + "static/media/aavaxb.9a9fd6fd.svg";
export { ForwardRef as ReactComponent };